// hook for registration, built around useAPI and react-hook-form
import { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'src/api'

import useAPI from 'src/hooks/useAPI'

import { SubscriptionContext } from 'src/contexts/SubscriptionContext'

interface IRegisterOptions {
  yj?: boolean
  group?: string
  hash?: string
  language?: string
}

const useRegister = (options: IRegisterOptions = {}) => {
  const [res, loading, req, err] = useAPI('/user/register', 'POST')
  const { affiliate, affiliate_campaign, affiliate_ad, chosenPlan } = useContext(SubscriptionContext)

  const [error, setError] = useState(null)
  const loginDispatch = useDispatch()

  useEffect(() => {
    if (!res) return
    if (res?.success) {
      loginDispatch({
        type: 'SIGN_IN',
        payload: res
      })
    }
  }, [res])

  useEffect(() => {
    if (!err) setError(null)
    else if (err.status === 409) setError('Email already in use, please try another')
    else setError('An error occurred, please try again')
    // @Colton it looks like proper error messages are being set in the registerUser func, but on a conflict for example
    // I just get a generic "Error registering user" message. So not sure if something is amiss -Mike
  }, [err])

  // assumes a react-hook-form data object as the first arg and an event as the second
  const onSubmit = async (data: any, e: any) => {
    e.preventDefault()
    setError(null)

    // if we were passed the yj flag, we need to do an availability check first
    if (options.yj) {
      const { password, email } = data
      const payload = {
        password: password.trim(),
        email: email.toLowerCase().trim(),
        hash: options.hash,
        sendEmail: false
      }

      const resCheck = await axios.post('/user/check-availability-yj', payload)

      if (!resCheck.data.success) {
        setError('YJ account not available')
        return
      }
    }
    req({ ...data, group: options.group, affiliate, affiliate_campaign, affiliate_ad, language: options.language || 'japanese', planSelectionAtSignup: chosenPlan })
  }

  return {
    onSubmit,
    res,
    loading,
    error
  }
}

export default useRegister
